import { __extends } from "tslib";
import React from 'react';
import { compose } from 'redux';
import Button from '../../../Button/Button';
import { withTranslation } from 'react-i18next';
import { ACCEPTED_FILE_MIME_TYPES } from '../../constants';
import IconButton from '../../../Button/IconButton';
import UploadIcon from '../../../Icons/Upload';
import { IconSize } from '../../../Icons/IconWrap';
import { withMobileContext } from '../../../Context';
import withFileUpload from '../../_hocs/withFileUpload';
import { withVerification, } from '../../../VerificationPopup/withVerification';
import withFeatureFlags from '../../_hocs/withFeatureFlags';
var enhance = compose(withFeatureFlags, withVerification, withFileUpload, withMobileContext, withTranslation());
var UploadButton = /** @class */ (function (_super) {
    __extends(UploadButton, _super);
    function UploadButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileInput = React.createRef();
        _this.chooseFile = function () {
            var _a = _this.props, isVerificationNeeded = _a.isVerificationNeeded, pushVerificationPopup = _a.pushVerificationPopup;
            if (isVerificationNeeded) {
                pushVerificationPopup('submit');
                return;
            }
            _this.fileInput.current.value = '';
            _this.fileInput.current.click();
        };
        _this.handleFileChange = function (e) {
            var file = e.target.files[0];
            if (!file) {
                return;
            }
            _this.props.uploadFile({ file: file });
        };
        return _this;
    }
    UploadButton.prototype.render = function () {
        var _a = this.props, className = _a.className, isMobile = _a.isMobile, t = _a.t;
        return (React.createElement(React.Fragment, null,
            isMobile && (React.createElement(IconButton, { className: 'astro', onClick: this.chooseFile },
                React.createElement(UploadIcon, { withPadding: true, size: IconSize.MEDIUM }))),
            !isMobile && (React.createElement(Button, { view: "b14", height: "medium", onClick: this.chooseFile, className: className },
                t('mediapopup.upload'),
                ' ')),
            React.createElement("input", { type: "file", ref: this.fileInput, onChange: this.handleFileChange, accept: ACCEPTED_FILE_MIME_TYPES.join(), style: { display: 'none' } })));
    };
    return UploadButton;
}(React.Component));
export default enhance(UploadButton);
//# sourceMappingURL=UploadButton.connected.js.map